/* global axios */
import ApiClient from './ApiClient';

class SupportTicketsApi extends ApiClient {
  constructor() {
    super('support_tickets', { accountScoped: true });
  }

  getAll({
    status,
    priority,
    q,
    assigneeId,
    hasComments,
    dueDate,
    page,
    perPage,
  } = {}) {
    return axios.get(this.url, {
      params: {
        status,
        priority,
        q,
        assignee_id: assigneeId,
        has_comments: hasComments,
        due_date: dueDate,
        page,
        per_page: perPage,
      },
    });
  }

  conversationOptions({ q, page } = {}) {
    return axios.get(`${this.url}/conversation_options`, {
      params: { q, page },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }

  getMessages(ticketId) {
    return axios.get(`${this.url}/${ticketId}/messages`);
  }

  createMessage({ ticketId, content }) {
    return axios.post(`${this.url}/${ticketId}/messages`, { content });
  }
}

export default new SupportTicketsApi();
